import * as Yup from 'yup'
import { TFunction } from 'i18next'
import { generateTranslationSchema } from '@/shared/lib/generateTranslationSchema'
import { defaultTranslationsCreate } from '@/entities/ContentTranslation/lib/translationDefaults'
import { LanguageTabConfig } from '@/features/MultilingualTabs/model/types'
import { CreateWebinarFormState } from '../model/types'

export const createWebinarFormDefault: CreateWebinarFormState = {
  translations: defaultTranslationsCreate,
  video_url: '',
  release_date: '',
  has_ai_translation: false,
  thumbnail: null,
}

export const createWebinarFormSchema = (t: TFunction, languageTabs: LanguageTabConfig[]) => {
  return Yup.object().shape({
    release_date: Yup.date().nullable(),
    video_url: Yup.string()
      .max(255, t('common:validation_messages.max', { count: 225 }))
      .required(t('common:validation_messages.required')),
    ...generateTranslationSchema(languageTabs, t, true).fields,
  })
}
